import React, { useState, useMemo } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  MultiAutocomplete,
  RadioGroup,
} from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function Relalteracaoencerrante() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);
  const [bico, setBico] = useState(0);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;

    return {
      ...params,
      idposto: idPosto,
      idbico: idBico,
    };
  }

  async function handleCarregaBicos(value) {
    console.log(value);
    // await reference.current.setFieldValue('automaticobico', value);
    // await setYesOrNo(value);
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.alteracaoencerrante')}
      relatorio="alteracaoencerrante"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      {/* <span>POSTO</span>
      <div>{`valuePosto: ${valuePosto !== null ? `'${valuePosto}'` : 'null'}`}</div>
      <div>{`inputValuePosto: '${inputValuePosto}'`}</div>

      <span>BICO</span>
      <div>{`valueBico: ${valueBico !== null ? `'${valueBico}'` : 'null'}`}</div>
      <div>{`inputValueBico: '${inputValueBico}'`}</div> */}

      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          setValueBico(0);
          setInputValueBico('');
          if (value[0]?.idposto !== null) {
            setPosto(value);
            setValuePosto(value);
          } else {
            setPosto(0);
            setValuePosto(0);
          }
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        getValue={(value) => {
          setValueBico(value.idbico);
        }}
        defaultValue=""
        hiddens={[{ name: 'idbico' }]}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        params={{
          wherefield: 'idposto',
          valuewherefield: valuePosto[0]?.idposto,
          typewherefield: 'EQUALS',
          fieldlist: 'idbico, idproduto, bicoprodutobico',
        }}
      />

      <PesquisaTabela
        name="codigousuario"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relalteracaoencerrante;
